import { Button } from 'antd';
import { isRTL } from 'core/services/language';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Icon from 'utils/icon';

function BackButton() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleNavigateBack = () => {
		navigate(-1);
	};

	return (
		<Button type="link" onClick={handleNavigateBack} style={{ color: '#a6a6a6', padding: 0, marginBottom: 5 }}>
			<Icon
				name="backArrow"
				width={15}
				height={15}
				color="#a6a6a6"
				style={{ transform: isRTL() && 'rotate(180deg)', marginTop: isRTL() && '3px' }}
			/>
			{t('COMMON.BACK')}
		</Button>
	);
}

export default BackButton;
